// extracted by mini-css-extract-plugin
export var container = "_ss-0";
export var inputWidth = "_ss-1";